import React from "react"
import loadable from "@loadable/component"

export default {
  component: loadable(
    () => import(/* webpackChunkName: "FileUpload" */ "./FileUpload"),
    {
      fallback: <div>Loading...</div>,
    }
  )
}
